import { CSSProperties } from "react";
import styled from "styled-components";
import theme from "styles/theme";

export const LobbyContainer = styled.div`
  margin-top: 5px;
  .ant-pagination {
    align-items: left;
    justify-content: left;
    display: flex;
    width: 100%;
    margin-top: 30px;
  }

  .ant-pagination-options {
    margin-left: auto;
  }
  .ant-pagination-total-text {
    margin-right: auto;
  }

  .ant-pagination-item {
    border: none;
  }
  .ant-pagination-item-link {
    border: none;
  }

  .pencilEdit {
    color: ${(props) => props.theme["@secondary-color"]};
    cursor: pointer;
  }

  .ant-table-thead tr .ant-table-selection-column div {
    display: none;
  }

  .ant-checkbox-wrapper {
    display: none;
  }

  .ant-table-row-expand-icon .ant-table-row-expand-icon-expanded button {
    display: none !important;
  }

  .ant-radio-wrapper .ant-radio-wrapper-checked .radioButton {
    border: 2px solid ${(props) => props.theme["@primary-color-brand"]} !important;
  }
`;

export const CloseDrawer = styled.span`
  .closeIcon > svg {
    color: ${(props) => props.theme["@input-border-color"]} !important;
    cursor: pointer !important;
    :hover {
      color: ${(props) => props.theme.colors.text} !important;
    }
  }
`;

export const ActionContainer = styled.div`
  display: grid;
  grid-template-columns: ${(props) => (props.allowRequestDockEntryAction ? `repeat(4, 1fr)` : `repeat(3, 1fr)`)};
  column-gap: 2px;
  > button {
    background: transparent;
    border: none;
    justify-content: flex-start;
    align-items: center;
    margin-right: auto;
    display: flex;
    color: ${(props) => props.theme.colors.text};
    &:hover {
      color: ${(props) => props.theme["@primary-color-brand"]};
    }
  }
  .viewRegister,
  .outRegister,
  .inboundCheckinRegister,
  .pencilEdit,
  .trashIcon,
  .vehicleEntryAuthorization,
  .vehicleActionRegister {
    cursor: pointer;
  }
`;

export const ActionContainerCheckin = styled.div`
  display: grid;
  grid-template-columns: ${(props) => (props.allowRequestVehicleInboundAction || props.allowRequestDockEntryAction ? `repeat(2, 1fr)` : `1fr`)};
  column-gap: 2px;
  > button {
    background: transparent;
    border: none;
    justify-content: flex-start;
    align-items: center;
    margin-right: auto;
    display: flex;
    color: ${(props) => props.theme.colors.text};
    &:hover {
      color: ${(props) => props.theme["@primary-color-brand"]};
    }
  }
  .inboundCheckinRegister,
  .vehicleActionRegister {
    cursor: pointer;
  }
`;

export const TruckExitIcon: CSSProperties = {
  marginRight: "10px",
  alignItems: "center",
  color: theme["@primary-color-brand"],
};

export const ShippingTruckIcon: CSSProperties = {
  marginRight: "10px",
  alignItems: "center",
};

export const FakeBtnConfirm: CSSProperties = {
  display: "none",
};

export const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-content: space-between;
`;

export const FormLayout: CSSProperties = {
  height: "100%",
};

export const TabContainer = styled.div`
  .ant-tabs-tab {
    color: ${(props) => props.theme.colors.text};
  }

  .ant-tabs-nav-list {
    margin-left: 7px;
  }

  .ant-tabs-top > .ant-tabs-nav {
    margin: 0;
  }

  .ant-tabs-tab-active {
    .ant-tabs-tab-btn {
      color: ${(props) => props.theme.colors.text};
      font-weight: 450;
    }
  }

  .ant-table-container table > thead > tr:first-child th:first-child {
    border-top-left-radius: 0px;
  }

  .ant-table-container table > thead > tr:first-child th:last-child {
    border-top-right-radius: 0px;
  }

  .ant-tabs-nav-wrap {
    border: 1.5px solid ${(props) => props.theme["@border-table"]};
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
  }

  .ant-tabs-ink-bar.ant-tabs-ink-bar-animated {
    background-color: ${(props) => props.theme["@primary-color-brand"]} !important;
  }
`;

export const TagStatus: CSSProperties = {
  fontSize: "14px",
  color: theme.colors.text,
  fontWeight: "600",
  borderRadius: "8px",
  textAlign: "center",
};
